/**
 * Indicates whether instruments are pre-listed only or can also be defined via user request
 * tag: 1198
 * @readonly
 * @enum {number} (int)
 */
export enum ListMethod {
  /** pre-listed only */
  PreListedOnly = 0,
  /** user requested */
  UserRequested = 1,
}
